import React, {useContext, useEffect, useState} from 'react';
import {Grid} from '@mui/material';
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../components/common/Loading";
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import TopBar from "../components/common/TopBar";
import SideNav from "./SideNav";

const _GebruikerMain = ({updateCurrentStep, providedCat}) => {
    const {t} = useTranslation();

    return (
        <div className="flex flex-col min-h-screen">
            <TopBar/>

            <div className="flex flex-1">
                <SideNav/>
                <main className="flex-1 p-4 overflow-auto">
                    <Outlet/>
                </main>
            </div>
        </div>
    )
};


export default withAuthenticationRequired(_GebruikerMain, {
    onRedirecting: () => <Loading/>,
    returnTo:
        '/nieuwe-reservatie'
});
